module.exports = __webpack_public_path__ + "img/typography-en-green.66809eef.png";